<template>
  <div :class="[deviceType, 'layer1']">
    <div class="header">
      <div :class="[deviceType, 'header-title']">{{ headers }}</div>
      <!-- <div class="timer">
        <img
          style="width: 20px; height: 20px"
          class="path-65"
          src="../../../../assets/icons/timer.svg"
        />
        <p>{{ prop.countDown }}</p>
      </div> -->
    </div>

    <div
      v-if="deviceType != 'Mobile' && currentStep != 2 && currentStep != 0"
      class="progress-bar"
    >
      <div
        class="progress-bar-inside"
        :style="{ width: progressBarWidth }"
      ></div>
    </div>
    <div v-else style="margin-bottom: 3px"></div>
    <div
      v-if="deviceType != 'Mobile' && currentStep != 2 && currentStep != 0"
      class="footer"
    >
      <div class="footer-text">{{ t("ccOnBoarding.start") }}</div>
      <div class="footer-text">{{ t("ccOnBoarding.end") }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
// @ts-ignore
import StepProgress from "vue-step-progress";
import { computed } from "vue";
import i18n from "@/plugin/i18n";
import { ref, onMounted } from "vue";
import { inject } from "vue";

const deviceType = inject("deviceType");

const { t } = i18n.global;

const prop = defineProps({
  currentStep: {
    type: Number,
    required: true,
  },
  cardName: {
    type: String,
  },
  type: {
    type: String,
  },
  eligibility: {
    type: Boolean,
  },
  countDown: {
    type: String,
  },
});

const progressBarWidth = computed(() => {
  const totalSteps = 11;
  const widthPercentage = (prop.currentStep * 100) / totalSteps;
  if (prop.currentStep == 15) {
    return `${50}%`;
  } else if (prop.currentStep == 16) {
    return `${100}%`;
  }
  return `${widthPercentage}%`;
});

const headers = computed(() => {
  switch (prop.currentStep) {
    case 0:
      if (prop.eligibility) {
        return `${t("ccOnBoarding.progressRoutePage.page0-1")}`;
      } else {
        return `${t("ccOnBoarding.progressRoutePage.page0-2")}`;
      }
    case 1:
      return `${t("ccOnBoarding.basicInformation.basicInformation")}`;
    case 2:
      if (deviceType === "Mobile") {
        return `${t("ccOnBoarding.ekyc.ekycQrCodeMobile")}`;
      } else {
        return `${t("ccOnBoarding.ekyc.ekycQrCode")}`;
      }
    case 3:
      return `${t("ccOnBoarding.contactVerification.contactVerification")}`;
    case 4:
      return `${t("ccOnBoarding.personalInformation.personalInformation")}`;
    case 5:
      return `${t("ccOnBoarding.emergencyContact.emergencyContact")}`;
    case 6:
      return `${t("ccOnBoarding.employmentDetails.employmentDetails")}`;
    case 7:
      return `${t("ccOnBoarding.principalCard.principalCardDetails")}`;
    case 8:
      return `${t("ccOnBoarding.uploadDocument.uploadDocument")}`;
    case 9:
      return `${t("ccOnBoarding.supplementary.supplementary")}`;
    case 10:
      return `${t("ccOnBoarding.supplementary.contact")}`;
    case 11:
      return `${t("ccOnBoarding.supplementary.uploadDoc")}`;
    case 15:
      return `${t("ccOnBoarding.additionalInformation.additionalInformation")}`;
    case 16:
      return `${t("ccOnBoarding.uploadDocument.uploadDocument")}`;
    default:
      return "";
  }
});
</script>
